import { LngLat, Popup } from "mapbox-gl";

export class MapboxMapPopup extends HTMLElement {
    _lngLat!: LngLat;
    anchor: mapboxgl.Anchor | undefined;
    closeButton: boolean = true;
    closeOnClick: boolean = true;
    closeOnMove: boolean = false;
    focusAfterOpen: boolean = true;
    maxWidth: string | undefined;
    offset: number | [number, number] | undefined;
    _popup: Popup | undefined;

    get lngLat(): LngLat {
        return this._lngLat;
    }

    set lngLat(value: LngLat) {
        if (this._popup) {
            this._popup.setLngLat(value);
        }
        this._lngLat = value;
    }

    connectedCallback() {
        console.debug("Connecting elm-mapbox-popup");
        let map = (this.parentElement as any)._map;
        if (!map) {
            console.warn(
                "elm-mapbox-popup element must be a child of an elm-mapbox-map",
            );
            return;
        }
        let content = this.firstElementChild?.cloneNode(true);
        if (!content) {
            console.warn(
                "elm-mapbox-popup has no content - it must have a single child element",
            );
            return;
        }

        this._popup = new Popup({
            anchor: this.anchor,
            className: this.className,
            closeButton: this.closeButton,
            closeOnClick: this.closeOnClick,
            closeOnMove: this.closeOnMove,
            focusAfterOpen: this.focusAfterOpen,
            maxWidth: this.maxWidth,
            offset: this.offset,
        })
            .setDOMContent(content)
            .setLngLat(this._lngLat)
            .addTo(map);

        // observe child element changes to update marker element
        const observer = new MutationObserver(() => {
            if (this._popup) {
                this._popup.setDOMContent(
                    this.firstElementChild?.cloneNode(true) ??
                        document.createElement("div"),
                );
                // If the map has dismissed the popup (e.g., via closeOnMove), and the popup has changed, this may be elm reusing the element - so re-add it.
                if (!this._popup.isOpen()) {
                    this._popup.addTo(map);
                }
            }
        });
        observer.observe(this, {
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true,
        });
    }

    disconnectedCallback() {
        console.debug("Disconnecting elm-mapbox-popup");
        this._popup?.remove();
        delete this._popup;
    }
}
